import React from 'react';
export function About() {
  return <section id="about" className="py-20 bg-white" data-id="element-14">
      <div className="container mx-auto px-4" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-17">
            Why Swedenmark Studio
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto" data-id="element-18"></div>
        </div>
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-19">
          <div className="space-y-6 md:order-2" data-id="element-20">
            <h3 className="text-2xl font-semibold text-gray-800" data-id="element-21">
              A different kind of digital partner
            </h3>
            <p className="text-gray-600" data-id="element-22">
              Most studios hand you a deliverable and walk away. We stay until
              the work is done — embedding with your team, building the systems,
              and measuring the outcomes that matter.
            </p>
            <p className="text-gray-600" data-id="element-23">
              We specialize in working with companies where thoughtful design
              and engineering create asymmetric value. You have real operational
              complexity but the agility to move fast — we help you turn that
              into an advantage.
            </p>
            <p className="text-gray-600" data-id="element-24">
              Our engagements are outcome-focused: defined deliverables, clear
              timelines, and measurable ROI. Every project is structured around
              what drives the best results for your business.
            </p>
            <div className="flex space-x-4 pt-2" data-id="element-25">
              <div className="h-12 w-1 bg-blue-500" data-id="element-26"></div>
              <blockquote className="italic text-gray-700" data-id="element-27">
                "Built for teams ready to move from good ideas to shipped
                products."
              </blockquote>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-28">
            <div className="aspect-square rounded-lg overflow-hidden" data-id="element-29">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Team collaborating" className="w-full h-full object-cover" data-id="element-30" />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden mt-8" data-id="element-31">
              <img src="https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Copenhagen harbor" className="w-full h-full object-cover" data-id="element-32" />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden" data-id="element-33">
              <img src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Designer at work" className="w-full h-full object-cover" data-id="element-34" />
            </div>
            <div className="aspect-square rounded-lg overflow-hidden mt-8" data-id="element-35">
              <img src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Modern workspace" className="w-full h-full object-cover" data-id="element-36" />
            </div>
          </div>
        </div>
        <div className="mt-16 pt-10 border-t border-gray-200 max-w-3xl mx-auto text-center" data-id="element-37">
          <p className="italic text-gray-500" data-id="element-38">
            Swedenmark Studio takes its name from our founders' Scandinavian
            roots — a nod to the Nordic tradition of building things that are
            precise, durable, and purposeful.
          </p>
        </div>
      </div>
    </section>;
}